import FilterRegister from "../../../../components/filter/register-basic";
import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqContaSaida from "../../../../services/reqMultiTenant/reqContaSaida";
import reqWhatsapp from "../../../../services/reqMultiTenant/reqWhatsApp";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import FormWhatsApp from "../form";
import Form from "../form";

const MainRegisterWhatsApp = () => {
	const options = {
		id: "id_whatsapp", //usado para saber qual field usar para atualizar
		ident: "whatsappConnect", //usado para definir os event listners
		identFilter: "filterWhatsApp", //usado para definir os event listners
		title: "WhatsApp Instância",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "descricao", label: "Nome da instância", align: "left", width: "250px" },
			{ key: "telefone", label: "Telefone", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Nome da instância", value: "descricao" }],
	};

	//#region Funções de acesso a dados do componente
	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const responseComplement = await reqWhatsapp.listPaginate(param, paramValue, active, newPage);

		return responseComplement;
	};

	const fetchID = async (currentId) => {
		const responseComplement = await reqWhatsapp.listID(currentId);

		return responseComplement;
	};

	const insert = async (data) => {
		const response = await reqWhatsapp.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={FormWhatsApp} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterWhatsApp;
